var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var menu = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-tooltip",
                {
                  attrs: { "open-delay": "300", top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var tooltip = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      color: _vm.color,
                                      disabled: _vm.disabled,
                                      block: _vm.$vuetify.breakpoint.xsOnly,
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                Object.assign({}, tooltip, menu)
                              ),
                              [
                                _vm.loading
                                  ? [
                                      _c("v-icon", [
                                        _vm._v(_vm._s(_vm.$MDI.ProgressWrench)),
                                      ]),
                                      _vm._v(" \n          "),
                                    ]
                                  : _vm._e(),
                                _vm._v("\n          Predict\n        "),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.show,
                    callback: function ($$v) {
                      _vm.show = $$v
                    },
                    expression: "show",
                  },
                },
                [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.error))])]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        [
          _c(
            "v-list-item",
            {
              attrs: {
                disabled: this.sequence.length >= 1200,
                "two-line": this.sequence.length >= 1200,
              },
              on: { click: _vm.predictT5 },
            },
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("3Di with ProstT5")]),
                  _vm._v(" "),
                  this.sequence.length > 1200
                    ? _c(
                        "v-list-item-subtitle",
                        {
                          staticClass:
                            "v-alert v-alert--outlined warning--text",
                        },
                        [
                          _vm._v(
                            "\n                Sequence can be at most 1200 residues long\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              attrs: {
                disabled: this.sequence.length > 400,
                "two-line": this.sequence.length > 400,
              },
              on: { click: _vm.predictESM },
            },
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Structure with ESMFold")]),
                  _vm._v(" "),
                  this.sequence.length > 400
                    ? _c(
                        "v-list-item-subtitle",
                        {
                          staticClass:
                            "v-alert v-alert--outlined warning--text",
                        },
                        [
                          _vm._v(
                            "\n                Sequence can be at most 400 residues long\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }